import React, { useState, useEffect } from "react";

const SessionNotice = () => {
  const [isVisible, setIsVisible] = useState(false);
  const noticeMessage = window._env_?.NOTICE;
  const noticeVersion = window._env_?.NOTICE_VERSION || "1.0";

  useEffect(() => {
    // Controlla se il messaggio esiste e se la versione è diversa da quella salvata
    if (noticeMessage) {
      const dismissedVersion = localStorage.getItem("notice-dismissed-version");
      if (dismissedVersion !== noticeVersion) {
        setIsVisible(true);
      }
    }
  }, [noticeMessage, noticeVersion]);

  const handleDismiss = () => {
    setIsVisible(false);
    // Salva la versione corrente per non mostrarla più
    localStorage.setItem("notice-dismissed-version", noticeVersion);
  };

  if (!isVisible || !noticeMessage) {
    return null;
  }

  return (
    <div className="notification is-warning is-light" style={{ margin: "1rem", position: "relative" }}>
      <button 
        className="delete" 
        onClick={handleDismiss}
        aria-label="Chiudi notifica"
      ></button>
      <div dangerouslySetInnerHTML={{ __html: noticeMessage }} />
    </div>
  );
};

export default SessionNotice;
